/**
 * A two-note cue before each story, synthesised so there is no audio file to ship. The phone
 * will want the same cue as an asset played through expo-audio; keep the shape (a rising
 * fifth, half a second, gentle) the same when that lands so the two feel like one product.
 */
let ctx: AudioContext | null = null;

export const CHIME_MS = 620;

export async function playChime(): Promise<void> {
  if (typeof AudioContext === 'undefined') return;
  ctx ??= new AudioContext();
  if (ctx.state === 'suspended') await ctx.resume();
  const t0 = ctx.currentTime + 0.02;
  // E5 then B5: a fifth up, the second note softer and longer so it fades under the voice.
  const notes: [number, number, number, number][] = [
    [659.25, 0, 0.22, 0.4],
    [987.77, 0.16, 0.16, 0.55],
  ];
  for (const [freq, at, gain, len] of notes) {
    const osc = ctx.createOscillator();
    const amp = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    amp.gain.setValueAtTime(0.0001, t0 + at);
    amp.gain.exponentialRampToValueAtTime(gain, t0 + at + 0.02);
    amp.gain.exponentialRampToValueAtTime(0.0001, t0 + at + len);
    osc.connect(amp).connect(ctx.destination);
    osc.start(t0 + at);
    osc.stop(t0 + at + len + 0.05);
  }
  await new Promise((r) => setTimeout(r, CHIME_MS));
}
